function formatStrAsNumber(value: string = '', precision: number = 0): string {
	const separator = '.';
	const pattern = /[^\d\.\,]/g;
	let replacedValue = value
		.replace(pattern, '')
		.replace(',', separator);
	let isSeparatorExists = false;
	
	replacedValue.split('').forEach((s, idx) => {
		if (s === separator) {
			if (!isSeparatorExists) {
				isSeparatorExists = true;
			} else {
				replacedValue = replacedValue.substring(0, idx);
			}
		}
	});

	if (typeof precision !== undefined) {
		const splittedValue = replacedValue.split('.');
		let fraction = splittedValue[1];

		if (fraction && fraction.length > precision) {
			fraction = fraction.substr(0, precision);
			replacedValue = `${splittedValue[0]}.${fraction}`;
		} else if (precision === 0) {
			replacedValue = splittedValue[0];
		}
	}

	return replacedValue;
}

export {
	formatStrAsNumber,
};
